(() => {
const ELEMENT_NAME = 'joffz-product-configurator';
if (customElements.get(ELEMENT_NAME)) return;
class JoffzProductConfigurator extends HTMLElement {
connectedCallback() {
if (this.abortController) return;
this.abortController = new AbortController();
this.signal = this.abortController.signal;
this.isRestoringHistory = false;
this.currentVariantId = null;
this.lastPaperFrame = 'print-only';
this.lastCanvasFrame = 'unframed';
this.lastPaperMount = 'no';
try {
this.cacheElements();
this.readData();
this.detectOptionKeys();
this.prepareIndexes();
this.bindEvents();
this.configureStaticAvailability();
this.restoreInitialState();
this.dataset.jpcReady = 'true';
} catch (error) {
console.error('[JoffzProductConfigurator] Initialization failed.', error);
this.dataset.jpcReady = 'false';
}
}
disconnectedCallback() {
this.abortController?.abort();
this.abortController = null;
this.signal = null;
}
cacheElements() {
this.variantSelect = this.querySelector('[data-jpc-native-variant]');
this.priceElement = this.querySelector('[data-jpc-price]');
this.comparePriceElement = this.querySelector('[data-jpc-compare-price]');
this.addButton = this.querySelector('[data-jpc-add-button]');
this.addLabel = this.querySelector('[data-jpc-add-label]');
this.soldOutMessage = this.addButton?.querySelector('.sold-out-message');
this.statusElement = this.querySelector('[data-jpc-status]');
this.captionElement = this.querySelector('[data-jpc-preview-caption]');
this.materialInputs = [...this.querySelectorAll('[data-jpc-material]')];
this.frameInputs = [...this.querySelectorAll('[data-jpc-frame]')];
this.mountInputs = [...this.querySelectorAll('[data-jpc-mount]')];
this.sizeInputs = [...this.querySelectorAll('[data-jpc-size]')];
this.paperFrameGroup = this.querySelector('[data-jpc-frame-group="paper"]');
this.canvasFrameGroup = this.querySelector('[data-jpc-frame-group="canvas"]');
this.mountFieldset = this.querySelector('[data-jpc-mount-fieldset]');
this.canvasNote = this.querySelector('[data-jpc-canvas-note]');
this.quantityInput = this.querySelector('[data-jpc-quantity-input]');
this.quantityMinus = this.querySelector('[data-jpc-quantity-minus]');
this.quantityPlus = this.querySelector('[data-jpc-quantity-plus]');
this.sizeDialog = this.querySelector('[data-jpc-size-dialog]');
this.sizeGuideOpen = this.querySelector('[data-jpc-size-guide-open]');
this.sizeGuideClose = this.querySelector('[data-jpc-size-guide-close]');
if (!this.variantSelect || !this.addButton || !this.priceElement) {
throw new Error('Required product form elements are missing.');
}
}
readData() {
const variantDataElement = this.querySelector('[data-jpc-variants]');
const labelsElement = this.querySelector('[data-jpc-labels]');
if (!variantDataElement || !labelsElement) {
throw new Error('Variant or translation data is missing.');
}
const parsedVariants = JSON.parse(variantDataElement.textContent || '[]');
this.labels = JSON.parse(labelsElement.textContent || '{}');
this.variants = parsedVariants.map((variant) => ({
...variant,
id: String(variant.id),
available: Boolean(variant.available),
options: variant.options || {},
}));
if (!this.variants.length) {
throw new Error('No variants were provided to the configurator.');
}
}
detectOptionKeys() {
this.optionKeys = Object.keys(this.variants[0]?.options || {});
const normalizedKeys = this.optionKeys.map((key) => ({ key, normalized: this.normalize(key) }));
this.finishOptionKey =
normalizedKeys.find(({ normalized }) => normalized.includes('finish'))?.key ||
normalizedKeys.find(({ normalized }) => normalized.includes('frame'))?.key ||
normalizedKeys.find(({ normalized }) => normalized.includes('material'))?.key ||
this.optionKeys[0];
this.sizeOptionKey =
normalizedKeys.find(({ normalized }) => normalized.includes('size'))?.key ||
normalizedKeys.find(({ normalized }) => normalized.includes('dimension'))?.key ||
this.optionKeys[1] ||
this.optionKeys[0];
if (!this.finishOptionKey || !this.sizeOptionKey) {
throw new Error('Finish and size options could not be identified.');
}
}
prepareIndexes() {
this.variantById = new Map();
this.variantByCombination = new Map();
this.finishValues = new Map();
this.sizeValues = [];
this.variants.forEach((variant) => {
this.variantById.set(variant.id, variant);
const finish = variant.options[this.finishOptionKey];
const size = variant.options[this.sizeOptionKey];
const combinationKey = this.combinationKey(finish, size);
this.variantByCombination.set(combinationKey, variant);
this.finishValues.set(this.normalize(finish), finish);
if (size && !this.sizeValues.includes(size)) this.sizeValues.push(size);
});
this.sizeMetrics = new Map(
this.sizeValues.map((size) => [size, this.parsePhysicalSize(size)])
);
}
}
window.JoffzProductConfigurator = JoffzProductConfigurator;
window.__JPC_ELEMENT_NAME = ELEMENT_NAME;
})();
